// extracted by mini-css-extract-plugin
export var colorSquare = "_un-0";
export var danger = "_un-5";
export var lightPink = "_un-8";
export var neutralBlue = "_un-7";
export var neutralYellow = "_un-6";
export var normal = "_un-1";
export var primary = "_un-2";
export var primaryLight = "_un-3";
export var solidBlack = "_un-g";
export var solidGreen = "_un-b";
export var solidLightBlue = "_un-d";
export var solidNavy = "_un-c";
export var solidOrange = "_un-f";
export var solidPink = "_un-e";
export var solidRed = "_un-9";
export var solidYellow = "_un-a";
export var success = "_un-4";